(() => {
  class PootretUpload extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.addEventListener('click', (event) => {
        if (!event.target.closest('[data-add-photo]')) return;
        const next = this.querySelector('[data-extra-photo][hidden]');
        if (next) { next.hidden = false; next.querySelector('input').focus(); }
        if (!this.querySelector('[data-extra-photo][hidden]')) this.querySelector('[data-add-photo]').hidden = true;
      });
      this.addEventListener('change', (event) => {
        const input = event.target;
        if (input.type !== 'file') return;
        const output = input.parentElement.querySelector('.pt-file-preview');
        const old = output.querySelector('img'); if (old) URL.revokeObjectURL(old.src);
        output.replaceChildren(); input.setCustomValidity('');
        const file = input.files[0]; if (!file) return;
        if (!['image/jpeg','image/png','image/webp'].includes(file.type) || file.size > 10 * 1024 * 1024) {
          input.value = ''; input.setCustomValidity('Kies een JPG-, PNG- of WebP-foto van maximaal 10 MB.');
          output.textContent = 'Deze foto kan niet worden gebruikt. Kies JPG, PNG of WebP, maximaal 10 MB.';
          input.reportValidity(); return;
        }
        const img = document.createElement('img'); img.src = URL.createObjectURL(file); img.alt = 'Voorbeeld van je gekozen foto';
        const caption = document.createElement('span'); caption.textContent = file.name;
        output.append(img, caption);
      });
    }
    disconnectedCallback() {
      this.querySelectorAll('.pt-file-preview img').forEach(img => URL.revokeObjectURL(img.src));
    }
  }
  if (!customElements.get('pootret-upload')) customElements.define('pootret-upload', PootretUpload);
  // Validate also when a theme component dispatches a submit event programmatically.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const upload = [...document.querySelectorAll('pootret-upload')].find(el => el.dataset.formId === form.id);
    if (upload && !form.reportValidity()) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.pt-mobile-nav a');
    if (link) link.closest('details').open = false;
  });
  document.addEventListener('shopify:cart:lines-update', () => {
    const root = window.Shopify?.routes?.root || '/';
    fetch(root + 'cart.js').then(r => { if (!r.ok) throw new Error(); return r.json(); }).then(cart => {
      document.querySelectorAll('.pt-cart-count').forEach(el => el.textContent = cart.item_count);
      document.querySelectorAll('.pt-cart').forEach(el => el.setAttribute('aria-label', `Winkelmandje, ${cart.item_count} artikelen`));
    }).catch(() => {});
  });
})();
